import { render, staticRenderFns } from "./RecyclableBoxInfoComponent.vue?vue&type=template&id=922673c0&scoped=true&"
import script from "./RecyclableBoxInfoComponent.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxInfoComponent.vue?vue&type=style&index=0&id=922673c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922673c0",
  null
  
)

export default component.exports